import { SyntheticEvent, useCallback, useMemo } from 'react';
import { GridFilterInputValueProps } from '@mui/x-data-grid-pro';
import { isStringArray } from 'components/common/dataGrid/filterGuards';
import { LabelledEntity } from 'shared/types/commonView';
import {
  createIdSet,
  filterEntitiesByIdSet,
  idsFromEntities,
} from 'shared/utils/id/entityIds';

export function useEntityFilterInput(
  available: LabelledEntity[],
  item: GridFilterInputValueProps['item'],
  applyValue: GridFilterInputValueProps['applyValue']
): {
  handleChange: (event: SyntheticEvent, value: LabelledEntity[]) => void;
  selectedValues: LabelledEntity[];
} {
  const handleChange = useCallback(
    (_event: SyntheticEvent, value: LabelledEntity[]): void => {
      const entityIds = idsFromEntities(value);
      applyValue({ ...item, value: entityIds });
    },
    [applyValue, item]
  );

  const selectedValues = useMemo(() => {
    if (!isStringArray(item.value)) return [];
    const selectedIds = createIdSet(item.value);
    return filterEntitiesByIdSet(available, selectedIds);
  }, [available, item.value]);

  return { handleChange, selectedValues };
}
